const TERMS = [
  "DISCIPLINE",
  "ACADEMIC EXCELLENCE",
  "CHARACTER FORMATION",
  "INTEREST REGISTRATIONS NOW OPEN",
  "YEARS 7–10",
  "FUTURE LEADERS",
  "PURPOSE-DRIVEN LEARNING",
  "A CULTURE OF BELONGING",
  "NO SCHOOL ZONE — ALL WELCOME",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {TERMS.map((term) => (
      <span key={term} className="flex items-center">
        <span className="px-8 font-serif text-base sm:text-lg font-medium tracking-[0.12em] text-slate-300">
          {term}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-gold/70" />
      </span>
    ))}
  </div>
);

export const Marquee = () => (
  <div data-testid="marquee-ticker" className="relative overflow-hidden bg-navy py-5 select-none">
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);
